module.exports = __webpack_public_path__ + "img/block.a8d91061.png";